import { Analytics } from '@cobliteam/analytics';
import { useUser } from '@cobliteam/hooks';
import { useTranslation } from '@cobliteam/i18n';
import { Button, Dialog } from '@cobliteam/ui/components';
import Icon from '@cobliteam/ui/icons';
import { Widget } from '@typeform/embed-react';

const FeedbackButton = () => {
  const { t } = useTranslation('app-header');
  const { user, session, hasNoValidGroups } = useUser();

  if (hasNoValidGroups) return null;

  return (
    <Dialog>
      <Dialog.Trigger asChild>
        <Button
          data-testid='app-header-feedback-button'
          variant='outlined'
          color='default'
          size='sm'
          startIcon={<Icon name='megaphone' />}
          className='group'
          onClick={() => Analytics.track('NavBar - Feedback - Click')}
        >
          {t('feedback.button')}
        </Button>
      </Dialog.Trigger>
      <Dialog.Content modalSize='lg'>
        <Dialog.Header>
          <Dialog.Title>{t('feedback.title')}</Dialog.Title>
          <Dialog.Description className='sr-only' />
          <Dialog.Close />
        </Dialog.Header>
        <Dialog.Body>
          <Widget
            id='xSep7a5p'
            className='h-[600px]'
            hidden={{
              email: user?.email || '',
              user_id: user?.id || '',
              name: user?.name || '',
              url: window.location.href || '',
              fleet_id: session?.fleet.id || '',
              fleet_name: session?.fleet.name || '',
            }}
          />
        </Dialog.Body>
      </Dialog.Content>
    </Dialog>
  );
};

export default FeedbackButton;
